export default "__VITE_ASSET__DL2z$ZSv__"